<div class="bars-container" [style.height.px]="height()">
  @for (score of dailyScores(); track $index) {
    <div class="bar-track" [style.border-radius.px]="barBorderRadius()">
      <div
        class="bar-fill"
        [style.height.%]="score * 100"
        [style.backgroundColor]="color()"
        [style.border-radius.px]="barBorderRadius() / 2"
      ></div>
    </div>
  }
</div>
